import React, { useState } from 'react';
import { Button, Card, Col, Container, Modal, Row, Form, Spinner, InputGroup } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { setLogout } from '../Auth/LoginSlice';
import { setActiveKey } from './ActiveKeySlice';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
    const userState = useSelector((state) => state?.cmsLogin?.userData);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [show, setShow] = useState(false);
    const [loader, setLoader] = useState(false);
    const [newPass, setNewPass] = useState();
    const [confirmPass, setConfirmPass] = useState();

    const [showNewPass, setShowNewPass] = useState(false);
    const [showConfPass, setShowConfPass] = useState(false);

    const [newPassErr, setNewPassErr] = useState(false);
    const [confirmPassErr, setConfirmPassErr] = useState(false);

    const closeModal = () => {
        setNewPass('');
        setConfirmPass('');

        // setOldPassErr(false);
        setNewPassErr(false);
        setConfirmPassErr(false);

        setShow(false);
    }


    const ifValidate = () => {

        let isValid = true;
        if (!newPass) {
            isValid = false;
            setNewPassErr(true);
        }
        else if (!confirmPass) {
            isValid = false;
            setConfirmPassErr(true);
        }
        else if (newPass !== confirmPass) {
            isValid = false;
            toast.error('Sorry, New & Confirm password doesnt matched');
        }

        return isValid;
    }

    const updatePass = async () => {
        setLoader(true);
        if (ifValidate()) {
            await fetch(process.env.REACT_APP_BASE_URL + '/user/setPassword', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ mobile: userState?.data?.user?.mobile, password: newPass, })
            }).then((res) => res.json()).then((response) => {
                if (response.message === 'Invalid password') {
                    setLoader(false);
                    toast.error('Sorry, Old password is incorrect');
                }
                if (response.message === 'Updated successfully') {
                    setLoader(false);
                    toast.success('Password updated successfully');
                    setShow(false);
                    setLoader(false)
                    setTimeout(() => {
                        dispatch(setLogout(null));
                        dispatch(setActiveKey(null));
                        navigate('/');
                    }, 2000);
                }
            }).catch((err) => {
                setLoader(false)
                console.log("Err while updating pass", err);
            })
        }
        else {
            setLoader(false);
        }
    }
    return (
        <div className='profile outletPadding'>
            <ToastContainer />
            <Container>
                <div className='d-flex justify-content-between'>
                    <h2><Icon.PersonFill className='me-1 w-auto' />Profile</h2>
                    <Button className='primaryBtn w-auto' onClick={() => setShow(true)}><Icon.Lock className='me-1' />Update Password</Button>
                </div>

                <Row className='mt-3'>
                    <Col md={5}>
                        <h5>Personal Details</h5>
                        <Card>
                            <div>
                                <h6><Icon.PersonFill className='me-2' />Name -</h6>
                                <p>{userState?.data?.user?.fullName}</p>
                            </div>

                            <div>
                                <h6><Icon.BriefcaseFill className='me-2' />Role - </h6>
                                <p>{userState?.data?.user?.userType?.charAt(0).toUpperCase() + userState?.data?.user?.userType.slice(1)}</p>
                            </div>

                            <div>
                                <h6><Icon.TelephoneFill className='me-2' />Mobile - </h6>
                                <p>{userState?.data?.user?.mobile}</p>
                            </div>

                        </Card>
                    </Col>
                </Row>
            </Container>

            <Modal show={show} onHide={closeModal} backdrop="static" keyboard={false} centered>
                <Modal.Header closeButton>
                    <h5>Update Password</h5>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className='mb-3'>
                        <Form.Label className='noselect'>New Password</Form.Label>
                        <InputGroup>
                            <Form.Control placeholder="Enter New Password" value={newPass} type={showNewPass ? "text" : "password"}
                                onChange={(e) => {
                                    setNewPass(e.target.value);
                                    e.target.value.length > 0 ? setNewPassErr(false) : setNewPassErr(true)
                                }} />
                            <InputGroup.Text onClick={() => setShowNewPass(!showNewPass)}>
                                {showNewPass ? <Icon.EyeSlash size={20} style={{ cursor: 'pointer' }} onClick={() => setShowNewPass(!showNewPass)} /> :
                                    <Icon.Eye size={20} style={{ cursor: 'pointer' }} />}
                            </InputGroup.Text>
                        </InputGroup>

                        {newPassErr ? <p className='errMsg'>Please enter valid new password</p> : ''}
                    </Form.Group>

                    <Form.Group>
                        <Form.Label className='noselect'>Confirm New Password</Form.Label>
                        <InputGroup>
                            <Form.Control placeholder="Enter Confirm Password" type={showConfPass ? "text" : "password"} value={confirmPass}
                                onChange={(e) => {
                                    setConfirmPass(e.target.value);
                                    e.target.value.length > 0 ? setConfirmPassErr(false) : setConfirmPassErr(true)
                                }} />
                            <InputGroup.Text onClick={() => setShowConfPass(!showConfPass)}>
                                {showConfPass ? <Icon.EyeSlash size={20} style={{ cursor: 'pointer' }} onClick={() => setShowConfPass(!showConfPass)} /> :
                                    <Icon.Eye size={20} style={{ cursor: 'pointer' }} />}
                            </InputGroup.Text>
                        </InputGroup>

                        {confirmPassErr ? <p className='errMsg'>Please enter valid confirm password</p> : ''}
                    </Form.Group>


                </Modal.Body>
                <Modal.Footer>
                    {
                        loader ? <Spinner /> : <>
                            <Button className="secondaryBtn" onClick={closeModal} > Cancel </Button>
                            <Button className='primaryBtn' onClick={updatePass}> Update </Button></>
                    }

                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Profile;